import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Config } from '../config';
import { ContentPortalMapping } from '../content-portal-mapping';
import { LoginDialogComponent } from '../login-dialog/login-dialog.component';
import { Menu } from '../menu';
import { MobileDialogComponent } from '../mobile-dialog/mobile-dialog.component';
import { QueryParam } from '../query-param';
import { ApiService } from '../services/api.service';
import { Response } from './../response';

@Component({
  selector: 'app-adventure',
  templateUrl: './adventure.component.html',
  styleUrls: ['./adventure.component.css']
})
export class AdventureComponent implements OnInit {

  menu!: Menu[];
  trendingList!: ContentPortalMapping[];
  recommendList!: ContentPortalMapping[];
  slideConfig: any;
  res!: Response;
  contentList!: ContentPortalMapping[];
  queryParam!: QueryParam;
  requestObj!: QueryParam;
  allList!: ContentPortalMapping[];



  contentUrl = 'https://1477157375.rsc.cdn77.org/repository/content';
  mobileNumber: any;

  gameConfig: Config = {} as Config;
  dialogRef: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private router: Router,
    private titleService: Title,
    private modal: NgbModal
  ) {
    this.activatedRoute.params.subscribe( params => console.log("4564564565"+JSON.stringify(params)) );

  }

  ngOnInit(): void {
    // this.getVideoConfig();
    this.trendingList = [];
    this.recommendList = [];
    this.menu = [];
    this.res = {} as Response;
    let storageName = this.apiService.getItem();
    this.queryParam = JSON.parse(
      localStorage.getItem(storageName) || 'undefined'
    );

    this.getConditionalDialogBox();

    this.getConfigData(this.queryParam.id, this.queryParam.lang, this.queryParam.theme);
    this.getMainData();
    this.getButtonCategories("/category/?id=16&lang=EN&categoryid=112&operator=2218&biller=IRAQCOM");

    this.slideConfig = {
      slidesToShow: 4,
      slidesToScroll: 4,
      speed: 1000,
      autoplay: true
    };

  }
  selectedIndex: number = 0;

  setIndex(index: number) {
    this.selectedIndex = index;
  }



  getMobileRes(mobileNumber: number, url:any){
    this.apiService.getMobileResponse(url).subscribe(
      (response: any) => {
        console.log('Mobile Reponse ===============', response);
        if(response === true){
          this.mobileNumber = mobileNumber;
          this.queryParam.sub = true;
          this.queryParam.mobileNumber = this.mobileNumber;
          let storageName = this.queryParam.id+this.queryParam.operator+this.queryParam.biller;
          localStorage.setItem(storageName, JSON.stringify(this.queryParam));        }
          else{
          this.openDialog();
        }
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

   getMainData() {

      this.requestObj = JSON.parse(JSON.stringify(this.queryParam));
      if(this.requestObj.lang == 'PT'){
        this.requestObj.lang = 'EN'
      }
    


     this.apiService.getData(this.requestObj).subscribe(
      (response: any) => {
        this.res = response;
        console.log("inside home module main data .............")

       // this.getMenuList(this.queryParam.lang, this.res.menu);


        if(this.queryParam.id == '437' && this.queryParam.biller == 'TPAY'){
            let trendingCount = 0;
            let recomendedCount = 0;
            for (let i = 0; i < this.res.contentmapping.length; i++) {
              if (this.res.contentmapping[i].cdm_url != '' && trendingCount <= 5) {
                if(this.res.contentmapping[i].cdm_content_path.includes("http://ginger.matrixads.in/repository/content/")){
                  this.trendingList.push(this.res.contentmapping[i]);

                }else{
                  this.res.contentmapping[i].cdm_content_path = "http://ginger.matrixads.in/repository/content"+this.res.contentmapping[i].cdm_content_path;
                  this.trendingList.push(this.res.contentmapping[i]);
                }
                trendingCount++;
              } else if (this.res.contentmapping[i].cdm_url == '' && this.res.contentmapping[i].cdm_content_path.includes('.mp4') && recomendedCount <= 3) {
                this.recommendList.push(this.res.contentmapping[i]);
                recomendedCount++;

              }
              if(trendingCount == 5 && recomendedCount == 3){
                break;
              }
            }

        }else if(this.queryParam.id == '375' && this.queryParam.biller == 'QANAWAT'){
          for (let i = 0; i < this.res.contentmapping.length; i++) {
            if(this.res.contentmapping[i].cdm_url != ''){
              if (i <= 4) {
                if(this.res.contentmapping[i].cdm_content_path.includes("http://ginger.matrixads.in/repository/content/")){
                  this.trendingList.push(this.res.contentmapping[i]);
                }else{
                  this.res.contentmapping[i].cdm_content_path = "http://ginger.matrixads.in/repository/content"+this.res.contentmapping[i].cdm_content_path;
                  this.trendingList.push(this.res.contentmapping[i]);
                }              }
                else if (i > 4 && i <= 8) {
                  if(this.res.contentmapping[i].cdm_content_path.includes("http://ginger.matrixads.in/repository/content/")){
                    this.recommendList.push(this.res.contentmapping[i]);
                  }else{
                    this.res.contentmapping[i].cdm_content_path = "http://ginger.matrixads.in/repository/content"+this.res.contentmapping[i].cdm_content_path;
                    this.recommendList.push(this.res.contentmapping[i]);
                  }               }

            }else{
              if (i <= 4) {
                this.trendingList.push(this.res.contentmapping[i]);
              } else if (i > 4 && i <= 8) {
                this.recommendList.push(this.res.contentmapping[i]);
              }
            }

          }
        }else if(this.queryParam.id == '493' && this.queryParam.biller == 'IRAQCOM'){
          let apkCount = 0;
          let videoCount = 0;

          for (let i = 0; i < this.res.contentmapping.length; i++) {
            if(this.res.contentmapping[i].cdm_content_path.includes(".apk")){
              if(apkCount < 2){
                this.recommendList.push(this.res.contentmapping[i]);
                apkCount++;
              }
            }else if(this.res.contentmapping[i].cdm_content_path.includes(".mp4")){
              if(videoCount < 2){
                this.recommendList.push(this.res.contentmapping[i]);
                videoCount++;
              }
            }

            if(apkCount >= 2 && videoCount >=2)
                break;


          }
        }else{
          for (let i = 0; i < this.res.contentmapping.length; i++) {

          if (i <= 4) {
            this.trendingList.push(this.res.contentmapping[i]);
          } else if (i > 4 && i <= 8) {
            this.recommendList.push(this.res.contentmapping[i]);
          }
        }


        }


        console.log(this.trendingList);
        console.log(this.recommendList);
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }



  getMenuList(lang:any, menuList:any){
    this.apiService.getMenus(menuList, lang).subscribe(
      (response: any) => {
        this.menu = response;
        if (this.menu.length > 0) this.getButtonCategories(this.menu[0].url);
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

   getButtonCategories(url: any = '') {
    this.apiService.getCats(url).subscribe(
      (response: any) => {
        console.log('Category ===============', response);
        this.contentList = response;
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  downloadApk(url: any){
    window.open(url, '_blank');

  }

  gotoHome(item: any) {
    if (this.gameConfig.name === 'game') {

      if(item.cdm_url === ''){
        window.open(
          'https://1477157375.rsc.cdn77.org/repository/content' +
            item.cdm_content_path,
          '_blank'
        );
      }else {
        window.open(item.cdm_url, '_blank');
      }




    } else {
      window.open(
        'https://1477157375.rsc.cdn77.org/repository/content' +
          item.cdm_content_path,
        '_blank'
      );
    }

  }

  getConfigData(data: any, lang: any, theme: any) {
    this.apiService.getConfigData(data, lang, theme).subscribe(
      (response: any) => {
        this.gameConfig = response;
        this.titleService.setTitle(this.gameConfig.header1);
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  openDialog(): void {

    const modalRef = this.modal.open(MobileDialogComponent, { size: 'md', backdrop: 'static',  keyboard: false });
    modalRef.result.then((data) => {
    }, (reason) => {
    });
  }

  getMobilePINRes(mobileNumber: number, pinNumber: number, operatorId: string, url: any){
    this.apiService.getMobilePINResponse(url).subscribe(
      (response: any) => {
        console.log('Mobile Reponse ===============', response);
        if(response !== null){
          this.queryParam.pin = pinNumber;
          this.queryParam.sub = true;
          this.queryParam.mobileNumber = mobileNumber;
          let storageName = this.queryParam.id+this.queryParam.operator+this.queryParam.biller;
          localStorage.setItem(storageName, JSON.stringify(this.queryParam));        }
          else{
          this.openLoginDialog();
        }
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  openLoginDialog(): void {

    const modalRef = this.modal.open(LoginDialogComponent, { size: 'md', backdrop: 'static',  keyboard: false });
    modalRef.result.then((data) => {
    }, (reason) => {
    });
  }

  getConditionalDialogBox(){
    if(this.apiService.isRedirct(this.queryParam.id, this.queryParam.biller)){
          if(this.queryParam.msisdn == undefined){
            if(this.queryParam.id == '426'){
              window.location.href = "http://wap.matrixads.in/mglobopay/SMartFrenSSHEGetRequest?serviceId="+1209;
            }else if(this.queryParam.id == '273'){
              window.location.href = "http://wap.matrixads.in/mglobopay/SMartFrenSSHEGetRequest?serviceId="+1212;

            }
          }
    }else if((this.queryParam.id === '298' || this.queryParam.id === '334') && this.queryParam.biller === 'TPAY' && this.queryParam.operator === "8966"){
      if(this.queryParam.mobileNumber == 0){
        this.queryParam.popup = true;
        this.openLoginDialog();
      }else{
        let url = "http://wap.globocom.info/mglobopay/tpayLoginByUsername?msisdn="+this.queryParam.mobileNumber+"&pin="+this.queryParam.pin+"&operatorId="+this.queryParam.operator;
        this.getMobilePINRes(this.queryParam.mobileNumber, this.queryParam.pin, this.queryParam.operator, url)
      }
    }else if((this.queryParam.id === '481' ) && this.queryParam.biller.toLowerCase() == ('ONE97').toLowerCase() ){
      if(this.queryParam.mobileNumber == 0){
        this.queryParam.popup = true;
        this.openDialog();
      }else{
        let url = "https://wap.matrixads.in/mglobopay/uaeONSSubscriptionStatus?msisdn="+this.queryParam.mobileNumber;
        this.getMobileRes(this.queryParam.mobileNumber,url)
      }
    }else if((this.queryParam.id == '375') && this.queryParam.biller.toLowerCase() == "QANAWAT".toLowerCase()){
      if(this.queryParam.mobileNumber == 0){
        this.queryParam.popup = true;
        this.openDialog();
      }else{
        let url = "http://wap.matrixads.in/mglobopay/qanawatKSAPortalValidation/"+this.queryParam.mobileNumber;
        this.getMobileRes(this.queryParam.mobileNumber, url)
      }
    }else if((this.queryParam.id == '401') && this.queryParam.biller.toLowerCase() == "ALTRUS".toLowerCase()){
      if(this.queryParam.mobileNumber == 0){
        this.queryParam.popup = true;
        this.openDialog();
      }else{
        let url = "http://wap.matrixads.in/mglobopay/altrusCheckSubscriptionStatus?msisdn="+this.queryParam.mobileNumber;
        this.getMobileRes(this.queryParam.mobileNumber, url)
      }
    }else if((this.queryParam.id == '453' || this.queryParam.id == '454') && this.queryParam.biller.toLowerCase() == "MTNMONEY".toLowerCase()){
      if(this.queryParam.mobileNumber == 0){
        this.queryParam.popup = true;
        this.openDialog();
      }else{
        let url = "https://wap.matrixads.in/mglobopay//fetchMTNBeninSubscriptionStatus/"+this.queryParam.serviceId+"/"+this.queryParam.mobileNumber;
        this.getMobileRes(this.queryParam.mobileNumber, url)
      }
    }else if((this.queryParam.id == '420' || this.queryParam.id == '421') && this.queryParam.biller.toLowerCase() == "AirtelMoney".toLowerCase()){
      if(this.queryParam.mobileNumber == 0){
        this.queryParam.popup = true;
        this.openDialog();
      }else{
        let url = "https://wap.matrixads.in/mglobopay//fetchAirtelNigerSubscriptionStatus/"+this.queryParam.serviceId+"/"+this.queryParam.mobileNumber;
        this.getMobileRes(this.queryParam.mobileNumber, url)
      }
    }else if((this.queryParam.id == '416') && this.queryParam.biller.toLowerCase() == "MediaWorld".toLowerCase()){
      if(this.queryParam.mobileNumber == 0){
        this.queryParam.popup = true;
        this.openDialog();
      }else{
        let url = "http://wap.matrixads.in/mglobopay/mediaWorldSubscriptionStatus/"+this.queryParam.serviceId+"/"+this.queryParam.mobileNumber;
        this.getMobileRes(this.queryParam.mobileNumber, url)
      }
    }else if(this.queryParam.id === '6' && this.queryParam.biller === 'TPAY' && (this.queryParam.operator === "9071" || this.queryParam.operator === "9073")){
      if(this.queryParam.mobileNumber == 0){
        this.queryParam.popup = true;
        this.openDialog();
      }else{
        let url = "http://wap.matrixads.in/mglobopay/tpaygamesworldPortalValidation/"+this.queryParam.mobileNumber;
        this.getMobileRes(this.queryParam.mobileNumber, url)
      }
    }
  }
}
